export const TIMEOUT_API_NODEJS_REQUEST = 4000;
